// extracted by mini-css-extract-plugin
module.exports = {"desc_section":"style_desc_section__34Yd-","desc_section__title":"style_desc_section__title__2EXu3","desc_section__text":"style_desc_section__text__16XcQ"};